import React from 'react'
import { useHistory } from 'react-router-dom'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { IconEdit } from '../../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { useApiFormAppStore } from '../../../../../../api-new/state/config'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleSubmitCreate } from '../../../../../../shared/form-simple/form-submit'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'

export const AppStoreAdd = () => {
  const history = useHistory()

  const { appID } = useParamsInt()

  const apiFormAppStore = useApiFormAppStore()

  const roleSysApp = useRoleSysApp()

  const handleSubmit = async data => {
    let appStore = await apiFormAppStore.post(data)
    if (roleSysApp.accessUpdate) history.push(`/admin/app/edit/${appID}/store/edit/${appStore.id}`)
    else history.push(`/admin/app/edit/${appID}/store`)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconEdit} text="add">
        <CardFullHeightScrollY title="add app store">
          <FormSimple onSubmit={handleSubmit}>
            <FormSimpleHiddenNumber name="appID" value={appID} />
            <FormSimpleText name="name" required autoFocus />
            <FormSimpleSubmitCreate backURL={`/admin/app/edit/${appID}/store`} />
          </FormSimple>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
